import { useSyncExternalStore } from "react";
import { cache } from "../utils/cacheUtils";

const subscribe = (onChange: () => void) => cache.onStatusChange(onChange);
const readOnly = () => cache.isReadOnly();
const browserOffline = () => cache.getStatus().browserOffline;

/**
 * The app's offline state straight from the CacheManager, so components
 * outside the Redux provider (dialogs in tests) can use it too: `readOnly`
 * when the browser is offline or the API keeps failing, `browserOffline` for
 * the browser's own view, and `savedAt` for when this user's saved data was
 * last written.
 */
export function useOffline() {
  const isReadOnly = useSyncExternalStore(subscribe, readOnly);
  const isBrowserOffline = useSyncExternalStore(subscribe, browserOffline);
  return {
    isReadOnly,
    browserOffline: isBrowserOffline,
    savedAt: isReadOnly ? cache.savedAt() : null,
  };
}
